import { FeedbackType } from '../../shared/enums/feedback-type.enum';
import { SpecificItem } from './specific-item.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export abstract class Feedback {
  private _extended!: string;

  public type!: FeedbackType;

  public compact!: string;

  public set extended(extended: string) {
    this._extended = extended;
  }

  public _specific: SpecificItem[] = [];

  protected static mapBaseProperties(feedback: Feedback, dto: any): void {
    feedback.type = dto.type;
    feedback.compact = dto.compact;
    feedback.extended = dto.extended;
    feedback._specific =
      dto.specific?.map((item: any) => SpecificItem.fromDto(item)) ?? [];
  }

  /**
   * Get a composed string of the extended and/or specific feedback items.
   */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  public get extended(): string {
    if (!this._specific && !this._extended) {
      return undefined as never;
    }

    if ((this._extended && !this._specific) || this._specific?.length === 0) {
      return this._extended;
    }

    if (!this._extended && this._specific?.length > 0) {
      return this.getHumanReadableSpecific();
    }

    return (
      this._extended + '<div>' + this.getHumanReadableSpecific() + '</div>'
    );
  }

  /**
   * Get a human-readable string of the specific feedback items. Items without
   * values are filtered out.
   */
  private getHumanReadableSpecific(): string {
    return this._specific
      .filter(
        (specificItem) =>
          specificItem.value !== undefined &&
          specificItem.value !== null &&
          specificItem.value !== '',
      )
      .map((specificItem: SpecificItem) => {
        const prefix: string = specificItem.isCorrect ? 'GOED' : 'FOUT';
        const prefixHeading: string =
          this.type !== FeedbackType.INFORMATIONAL
            ? `<strong>${prefix}</strong> `
            : '';
        return `<div class="ion-margin-bottom">${prefixHeading}${specificItem.value}</div>`;
      })
      .join('');
  }
}
